import type { Locale } from "@/lib/i18n/locales";
import {
  deCatalog,
  messageCatalogs,
  type Messages,
} from "@/messages/buildCatalog";

export type { Messages };

export function getMessages(locale: Locale): Messages {
  return messageCatalogs[locale] ?? messageCatalogs.de;
}

/** Default German catalog (e.g. metadata fallbacks, slug generation). */
export { deCatalog };
